

























































































































































































































































  import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
  import Util from '../../lib/util'
  import AbpBase from '../../lib/abpbase'
  import TransferOrder from '../../store/entities/transferorder'
  import appconst from '../../lib/appconst'

  
   
  
  @Component
  export default class DetailTransferOrder extends AbpBase{


      
      @Prop({type:Boolean,default:false}) value:boolean;
      user:TransferOrder=new TransferOrder();
      pname:string="";
      cname:string="";
      vname:string="";
      disposalmethod=Array.from(["其他"]);;
      transportationtime:string="";
      signeetime:Date;
      getdeclarestatustxt(id){
          var txt="-";
             var list =this.$store.state.transferorder.declarestatus;
           list.forEach(item=>{
                 if(id==item.id){
                  txt=item.name;
                  return txt;
                 }
           })
           return txt;
 }
 getdispatchcarstatustxt(id){
          var txt="-";
             var list =this.$store.state.transferorder.dispatchcarstatus;
           list.forEach(item=>{
                 if(id==item.id){
                  txt=item.name;
                  return txt;
                 }
           })
           return txt;
 }
 getsignstatustxt(id){
          var txt="-";
             var list =this.$store.state.transferorder.signstatus;
           list.forEach(item=>{
                 if(id==item.id){
                  txt=item.name;
                  return txt;
                 }
           })
           return txt;
 }
      save(){
          
          
             this.user.signeetime= new Date(this.signeetime.toLocaleDateString()) ;  
             this.user.disposalmethod= this.disposalmethod.join(",");
          (this.$refs.userForm as any).validate(async (valid:boolean)=>{
              //  console.log(this.disposalmethod.join(","))
            
              
             
              if(valid){
                  await this.$store.dispatch({
                      type:'transferorder/updatetransferorderreception',
                      data:this.user
                  });
                  (this.$refs.userForm as any).resetFields();
                  this.$emit('save-success');
                  this.$emit('input',false);
              }
          })
      }
      cancel(){
          (this.$refs.userForm as any).resetFields();
          this.$emit('input',false);
      }
      visibleChange(value:boolean){
             
            
          if(!value){
              this.$emit('input',value);
            
         
          }else{
       
               this.user=Util.extend(true,{},this.$store.state.transferorder.editTransferOrder);
               if(this.user.transportationtime!=null){
                  this.transportationtime=new Date( this.user.transportationtime).toLocaleDateString();
               }
               this.signeetime=new Date(this.currentDate());
              //  this.disposalmethod=['其他'];
               this.user.signee=this.$store.state.transferorder.uname;
               this.user.signforweight=this.user.transweight;
              
               this.pname=this.$store.state.transferorder.editTransferOrder.productionWaste.corporatename;
               this.cname=this.$store.state.transferorder.editTransferOrder.collectionOffice.corporatename;
               this.vname=this.$store.state.transferorder.editTransferOrder.transPorted.corporatename;
              
               this.user.acceptingunitleader=this.$store.state.transferorder.editTransferOrder.collectionOffice.contacts;

         
              
          }
      }
        created() {
         
      }
currentDate() {
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;  // 注意月份从0开始，需要加1
    let day = currentDate.getDate();
    
    return year + "-" + month + "-" + day;
  }

      userRule={
        
          
          signforweight:[{required: true,message:'请输入签收量'}],
          signeetime:[{type:'date',required: true,message:'请选择运输日期'}],
          // waybillnumber:[{required: true,message:'请输入运单号'}],
          signee:[{required: true,message:'请输入接收人'}],
          disposalmethod:[{required: true,message:'请选择处置方式'}],
          acceptingunitleader:[{required: true,message:'请输入接受单位负责人'}],












      }

          //运输企业
  get transportedlist(){
     var items=this.$store.state.transferorder.enterpriseinformationllist;
      var  list=items.filter(item => item.corporatetype === 3)
      return list;
      
  }
  
      

 
      
  }  

  

  
 
